import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'vacaciones',
})
export class VacacionesPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {


    if (items) {
      items = items.filter(function (item) {

        return item.pasado == filter['pasado'];

      });

      return items;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/vacaciones/vacaciones.ts